/** @jsx h */
import { h } from 'preact'

const InfoIcon = ({ style = {}, width = '4.217', height = '13', className = '', viewBox = '0 0 4.217 13' }) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`info-icon ${className}`}
    aria-hidden='true'
  >
    <g transform='translate(0 0)'>
      <path
        d='M153.857,57.966a.076.076,0,0,1,.044.081l-1.922,6.8a4.527,4.527,0,0,0-.133.647.512.512,0,0,0,.057.248c.032.076.11.114.238.114.215,0,.5-.188.857-.562a10.674,10.674,0,0,0,.771-.952l.248.209-.1.133a10.279,10.279,0,0,1-1.18,1.437,2.142,2.142,0,0,1-1.427.685.835.835,0,0,1-.681-.343,1.266,1.266,0,0,1-.271-.809,2.67,2.67,0,0,1,.038-.481c.025-.136.073-.337.143-.6l1.354-4.892c.019-.076.035-.146.047-.209a.9.9,0,0,0,.019-.19.389.389,0,0,0-.252-.424,3.942,3.942,0,0,0-.993-.08v-.315q.784-.1,1.129-.147t.694-.11q.453-.076.86-.172A1.122,1.122,0,0,1,153.857,57.966Zm-.9-2.384a1.053,1.053,0,0,1-.276-.733,1.066,1.066,0,0,1,.276-.742.867.867,0,0,1,.666-.3.881.881,0,0,1,.671.3,1.055,1.055,0,0,1,.281.742,1.041,1.041,0,0,1-.281.738.889.889,0,0,1-.671.3A.867.867,0,0,1,152.96,55.582Z'
        transform='translate(-150.361 -53.802)'
      />
    </g>
  </svg>
)

export default InfoIcon
